<td-wb-tooltip-button [tdWbOverlayToggle]="goalAssumptionsTooltip"
                      [ariaLabel]="'tdWb.lti.assumptions.tooltip.MORE_INFORMATION' | translate"
                      [tooltipPosition]="position()"
                      tooltipSize="medium" />
<ng-template #goalAssumptionsTooltip>
  <td-wb-overlay>
    <div class="td-wb-body-small">
      <span [innerHTML]="'tdWb.lti.assumptions.tooltip.'+ sectionId() | translate"></span>
      @if (sectionId() === 'STANDARD_DEVIATION') {
        <a class="td-wb-link td-wb-link--underlined"
           tdWbOpenWindow="link_lti_methodology_whitepaper">
          <span translate="tdWb.lti.assumptions.tooltip.METHODOLOGY"></span>
        </a>
      }
    </div>
  </td-wb-overlay>
</ng-template>
